import React, { ReactNode, useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import styles from './index.less'
import { useStore, setShowRewardPop } from '@/states/store'

export const PopDialog = ({ onCancel }: any) => {
  const baseStore = useStore()

  useEffect(() => {
    const timer = setTimeout(() => {
      onCancel()
    }, 60000)

    return () => {
      clearTimeout(timer)
    }
  }, [0])

  useEffect(() => {
    if (baseStore.isLogin && !baseStore.showRewardPop) {
      // console.log('baseStore.showRewardPopclose')
      onCancel()
    }
  }, [baseStore.showRewardPop])

  return (
    <div className={styles.pop} style={{top:140}}>
      <img src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/icon_gift.png" alt="" />
      获得<span>&nbsp;200微力&nbsp;</span>登录奖励
      <div className={styles.btn} onClick={() => onCancel()}>
        开心收下
      </div>
    </div>
  )
}

export const openPopDialog = () => {
  // const { onClose, onSuccess, ...rest } = params
  const dom = document.getElementById('popDialog')
  dom && dom.parentElement && dom.parentElement.removeChild(dom)
  const container = document.createElement('div')
  // const id = new Date().getTime() + 'exportDialog';
  const id = 'popDialog'
  container.setAttribute('id', id)
  console.log('headerheader',document.getElementById('header'))
  if(!document.getElementById('header')){
    document.body.appendChild(container)
    container.style.position='fixed',
    container.style.top='140px',
    container.style.right='74px'
    container.style.zIndex='9999'
  }else{
    document?.getElementById('header')?.appendChild(container)
    container.style.position='absolute',
    container.style.bottom='-69px',
    container.style.right='74px'
  }
  const root = ReactDOM.createRoot(container)

  const cancel = () => {
    setShowRewardPop(false)
    root.unmount()
    container && container.parentElement && container.parentElement.removeChild(container)
  }
  window.addEventListener('popstate', function (event) {
    cancel()
  })

  return root.render(
    <PopDialog
      onCancel={(e: any) => {
        cancel()
      }}
    />,
  )
}
